<div class="item" *ngIf="repair_logs?.length != 0 && !data.status_youtube">
  <span class="label">补偿时间：</span>
  <span>{{ repair_logs?.[repair_logs?.length - 1].hours }}小时</span>
</div>
